import Button from '@mui/material/Button';
import * as React from 'react';
import { CircularProgress } from '@mui/material';
import { useTheme } from '@emotion/react';
import { ColorContext } from '../../AppTheme';

const ContainedButton = ({
  circleSize,
  isTextEmpty,
  children,
  isLoading,
  sx,
  fullWidth,
  onClick,
  loadingProps,
  ...props
}) => {
  const theme = useTheme();
  const { mode } = React.useContext(ColorContext);
  return (
    <Button
      variant={'contained'}
      disabled={isTextEmpty || isLoading}
      sx={{
        background: mode === 'dark' && 'none',
        borderRadius: '6px',
        minWidth: '80px',
        minHeight: '36px',
        width: fullWidth ? '100%' : 'auto',
        textTransform: { xs: 'none' },
        fontWeight: { xs: 500 },
        boxShadow: 'none',
        color: theme.palette.button.textContained,
        border: mode === 'dark' && `1px solid ${theme.palette.button.border}`,
        '&:hover': {
          boxShadow: 'none',
          ...(sx?.['&:hover'] || {})
        },
        ...sx
      }}
      onClick={isLoading ? undefined : onClick}
      {...props}>
      {isLoading ? (
        <CircularProgress size={circleSize || 24} color={'inherit'} {...loadingProps} />
      ) : (
        children
      )}
    </Button>
  );
};

export default ContainedButton;
